import { render, staticRenderFns } from "./boardWarehousingOutDetail.vue?vue&type=template&id=387826b3&scoped=true&"
import script from "./boardWarehousingOutDetail.vue?vue&type=script&lang=js&"
export * from "./boardWarehousingOutDetail.vue?vue&type=script&lang=js&"
import style0 from "./boardWarehousingOutDetail.vue?vue&type=style&index=0&id=387826b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387826b3",
  null
  
)

export default component.exports